(function () {
  function hashString(value) {
    var hash = 2166136261;

    for (var index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash +=
        (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }

    return hash >>> 0;
  }

  function getSeed(seedMode) {
    if (seedMode === 'session') {
      var sessionSeed = sessionStorage.getItem('collection-random-seed');

      if (!sessionSeed) {
        sessionSeed = String(Date.now());
        sessionStorage.setItem('collection-random-seed', sessionSeed);
      }

      return sessionSeed;
    }

    var now = new Date();
    return [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-');
  }

  function getItemUrl(item) {
    var link = item.querySelector('a[href]');
    return link ? link.href : item.textContent;
  }

  function prioritizeFirstRow(items) {
    var firstRowSize = window.matchMedia('(min-width: 990px)').matches ? 3 : 2;

    items.slice(0, firstRowSize).forEach(function (item) {
      var image = item.querySelector('.card__media img');

      if (image) {
        image.loading = 'eager';
        image.decoding = 'async';
        image.setAttribute('fetchpriority', 'high');
      }
    });
  }

  function applyRandomOrder(node) {
    var seedKey = node.dataset.seedKey || node.dataset.collectionHandle;
    var gridSelector = node.dataset.gridSelector || '#product-grid';
    var grid = (node.parentElement && node.parentElement.querySelector(gridSelector)) ||
      document.querySelector(gridSelector);
    var itemSelector = node.dataset.itemSelector || '.grid__item';
    var seed = seedKey + ':' + getSeed(node.dataset.seedMode || 'daily');
    var search = window.location.search;

    if (!seedKey || !grid) {
      node.dataset.randomizerStatus = 'skipped';
      return;
    }

    var items = Array.prototype.slice.call(grid.querySelectorAll(itemSelector));
    var pendingItems = items.filter(function (item) {
      return item.dataset.randomizedSeed !== seed;
    });
    var sortedItems = pendingItems
      .map(function (item, originalIndex) {
        return {
          item: item,
          originalIndex: originalIndex,
          sortKey: hashString(seed + ':' + getItemUrl(item)),
        };
      })
      .sort(function (left, right) {
        return left.sortKey - right.sortKey || left.originalIndex - right.originalIndex;
      })
      .map(function (entry) {
        return entry.item;
      });

    sortedItems.forEach(function (item) {
      item.dataset.randomizedSeed = seed;
      grid.appendChild(item);
    });

    if (pendingItems.length === items.length) {
      prioritizeFirstRow(sortedItems);
    }
    grid.dataset.randomizedSeed = seed;
    grid.dataset.randomizedSearch = search;
    node.dataset.randomizerStatus = 'applied';
    node.dataset.randomizerTotalItems = String(items.length);
  }

  function init() {
    document.querySelectorAll('[data-collection-randomizer]').forEach(function (node) {
      try {
        applyRandomOrder(node);
      } catch (error) {
        node.dataset.randomizerStatus = 'error';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:product-grid:rendered', init);
  document.addEventListener('shopify:section:load', init);
})();
